export default "__VITE_ASSET__DN$XLfXV__"